import React from 'react';
import { MultiOptionDatePicker } from '@/components/MultiOptionDatePicker/MultiOptionDatePicker';
import { Grid2x2, ListIcon } from 'lucide-react';
import { GridIcon } from 'lucide-react';

export const VIEW_OPTIONS = [
	{
		key: 'dayGridMonth',
		label: 'Month',
		icon: <Grid2x2 className="mr-1" />,
	},
	{
		key: 'timeGridWeek',
		label: 'Week',
		icon: <GridIcon className="mr-1" />,
	},
	{
		key: 'timeGridDay',
		label: 'Day',
		icon: <ListIcon className="mr-1" />,
	},
];

interface CalendarEventsToolBarProps {
	currentView: string;
	onViewChange: (view: string) => void;
	pickerMode: any;
	setPickerMode: (mode: any) => void;
	dateValue: any;
	setDateValue: (date: any) => void;
	rangeValue: [any, any];
	setRangeValue: (range: [any, any]) => void;
	showDatePicker: boolean;
	setShowDatePicker: (show: boolean) => void;
	handleDatePickerOk: (clear?: boolean) => void;
	handleToday: () => void;
}

export const CalendarEventsToolBar: React.FC<CalendarEventsToolBarProps> = ({
	currentView,
	onViewChange,
	pickerMode,
	setPickerMode,
	dateValue,
	setDateValue,
	rangeValue,
	setRangeValue,
	showDatePicker,
	setShowDatePicker,
	handleDatePickerOk,
	handleToday,
}) => {
	return (
		<div className="flex space-x-2 items-center space-between">
			{VIEW_OPTIONS.map((opt) => (
				<button
					key={opt.key}
					className={`h-fit toolbar-btn flex items-center px-4 py-2 rounded-lg border font-semibold text-base transition-all ${currentView === opt.key ? 'bg-gradient-to-r from-[#3b82f6] to-[#1d4ed8] text-white' : 'bg-white text-gray-900 border-gray-200 hover:bg-violet-50'}`}
					onClick={() => onViewChange(opt.key)}
				>
					{opt.icon} {opt.label}
				</button>
			))}
			<MultiOptionDatePicker
				pickerMode={pickerMode}
				setPickerMode={setPickerMode}
				dateValue={dateValue}
				setDateValue={setDateValue}
				rangeValue={rangeValue}
				setRangeValue={setRangeValue}
				showDatePicker={showDatePicker}
				setShowDatePicker={setShowDatePicker}
				handleDatePickerOk={handleDatePickerOk}
			/>
			<button
				className="toolbar-btn h-fit px-4 py-2 rounded-lg border border-gray-200 font-semibold text-base bg-white text-gray-900 hover:bg-violet-50"
				onClick={handleToday}
			>
				Today
			</button>
		</div>
	);
};
